import { useCallback, useEffect, useMemo, useState } from 'react';

interface UseLobbyTeamSelectProps {
	userId: string | undefined;
	lobbyId: string | undefined;
	teams: any[] | undefined;
}

export function useLobbyTeamSelect({ userId, lobbyId, teams }: UseLobbyTeamSelectProps) {
	const teamSelectKey = useMemo(
		() => (userId && lobbyId ? `teamSelectShown:${userId}:${lobbyId}` : null),
		[userId, lobbyId]
	);
	const [showTeamSelect, setShowTeamSelect] = useState(false);

	const handleCloseTeamSelect = useCallback(() => {
		if (teamSelectKey) {
			localStorage.setItem(teamSelectKey, '1');
		}
		setShowTeamSelect(false);
	}, [teamSelectKey]);

	useEffect(() => {
		if (!teamSelectKey) return;
		const hasTeams = Array.isArray(teams) && teams.length > 0;
		const alreadySeen = localStorage.getItem(teamSelectKey) === '1';
		if (hasTeams && !alreadySeen) {
			setShowTeamSelect(true);
		}
	}, [teamSelectKey, teams]);

	return { teamSelectKey, showTeamSelect, handleCloseTeamSelect };
}
